import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-custom-tabs',
  templateUrl: './custom-tabs.component.html',
  styleUrl: './custom-tabs.component.scss'
})
export class CustomTabsComponent {

  @Input() tabs:string[]=[];
  @Input() selectedTab:string='';
  @Output() onTabChange = new EventEmitter<string>();

  constructor(){}

}
